import React from 'react';
import { AnnouncementBanner } from '../components/AnnouncementBanner';
import { HeroSection } from '../components/HeroSection';
import { StatsBar } from '../components/StatsBar';
import { VendorLogos } from '../components/VendorLogos';
import { FeatureCards } from '../components/FeatureCards';
import { HowItWorks } from '../components/HowItWorks';
import { ModelShowcase } from '../components/ModelShowcase';
import { PricingPreview } from '../components/PricingPreview';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <>
      <AnnouncementBanner data-id="element-490" />
      <main data-id="element-491">
        <HeroSection data-id="element-492" />
        <StatsBar data-id="element-493" />
        <VendorLogos data-id="element-494" />
        <FeatureCards data-id="element-495" />
        <HowItWorks data-id="element-496" />
        <ModelShowcase data-id="element-497" />
        <PricingPreview data-id="element-498" />
        <CTASection data-id="element-499" />
      </main>
      <Footer data-id="element-500" />
    </>;
}